var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"passwordReset"},[_c('PasswordResetForm',{attrs:{"error":_vm.error,"submitMessage":_vm.submitMessage},on:{"password-reset":_vm.processPasswordReset,"clear-error":_vm.clearError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }